import { BRAND_CEL, BRAND_RCI } from 'contexts/CruiseSearchContext/constants';

export const GraphClientName = {
	NEXT_GEN_CRUISE_SEARCH: {
		[BRAND_CEL.code]: `${BRAND_CEL.alpha3Code}-NextGen-Cruise-Search`,
		[BRAND_RCI.code]: `${BRAND_RCI.alpha3Code}-NextGen-Cruise-Search`,
	},
	INITIAL_LOAD: {
		[BRAND_CEL.code]: `${BRAND_CEL.alpha3Code}-initialLoadNextGenClient`,
		[BRAND_RCI.code]: `${BRAND_RCI.alpha3Code}-initialLoadNextGenClient`,
	},
	MY_OFFERS: {
		[BRAND_CEL.code]: `${BRAND_CEL.alpha3Code}-myOffersNextGenClient`,
		[BRAND_RCI.code]: `${BRAND_RCI.alpha3Code}-myOffersNextGenClient`,
	},
};

export enum GraphServer {
	CRUISE_SEARCH = 'CRUISE_SEARCH',
	GLOBALIZATION = 'GLOBALIZATION',
	CAMPAIGNS = 'CAMPAIGNS',
}
